import React, { useEffect } from 'react';
import { Box, CssBaseline, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';
import { setSidebarOpen } from '../../store/slices/uiSlice';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const Layout = ({ children, currentPage, setCurrentPage }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const sidebarOpen = useSelector((state) => state.ui.sidebarOpen);

  useEffect(() => {
    if (!isMobile) {
      dispatch(setSidebarOpen(true));
    }
  }, [isMobile, dispatch]);

  const sidebarWidth = isMobile ? 0 : (sidebarOpen ? 280 : 80);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <CssBaseline />
      <Sidebar 
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: isMobile ? '100%' : `calc(100% - ${sidebarWidth}px)`,
          minHeight: '100vh',
          background: `linear-gradient(135deg, ${theme.palette.background.default}, ${theme.palette.background.default}95)`,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          ml: isMobile ? 0 : 0,
        }}
      >
        <Navbar 
          sidebarWidth={sidebarWidth} 
          setCurrentPage={setCurrentPage}
          isMobile={isMobile}
        />
        <Box sx={{ 
          mt: isMobile ? 7 : 8,
          p: { xs: 2, sm: 3 },
        }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;